import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { parseHtml } from '../../utils/util';

/**
 * return single and grouped radio buttons
 * based on isFieldGrouped flag passed
 * @param {*} param0
 */
const GroupCheckboxesMultiSelect = ({
  fieldOptions,
  fieldValidation,
  formSubmissionPayload,
  setFormSubmissionPayload,
}) => {
  const [selected, setSelected] = useState(0);
  const [options, setOptions] = useState(fieldOptions.map((opt) => ({ ...opt })));
  const customInvalidMsg = fieldValidation && fieldValidation.customInvalidMsg;
  const [showCustomInvalidMsg, setShowCustomInvalidMsg] = useState(false);

  const handleOnChange = (e, option) => {
    if (e.target.checked) {
      option.optionSelected = true;
      setFormSubmissionPayload({ ...formSubmissionPayload, elemId: null, [option.fieldId]: 'Yes' });
      setSelected((prev) => prev + 1
      );
    } else {
      option.optionSelected = false;
      delete formSubmissionPayload[option.fieldId];
      setFormSubmissionPayload({ ...formSubmissionPayload, elemId: null });
      setSelected((prev) => prev - 1
      );
    }
  //  setValue(selectedVal);
  };

  useEffect(() => {
    let numberOfSelectedOptions = 0;
    options.forEach((option) => {
      if (formSubmissionPayload && formSubmissionPayload[option.fieldId]
        && !option.optionSelected) {
        option.optionSelected = true;
        numberOfSelectedOptions += 1;
      }
    });
    if (numberOfSelectedOptions > 0) {
      setSelected(numberOfSelectedOptions);
    }
  }, [formSubmissionPayload]);

  useEffect(() => {
    if (selected > 0) {
      const newOptions = [];
      options.forEach((option) => {
        const cur = { ...option };
        cur.fieldValidation.required = false;
        newOptions.push({ ...cur });
      });
      setOptions([...newOptions]);
    } else {
      const newOptions = [];
      options.forEach((option) => {
        const cur = { ...option };
        cur.fieldValidation.required = true;
        newOptions.push({ ...cur });
      });
      setOptions([...newOptions]);
    }
  }, [selected]);

  const invalidHandler = (e) => {
    e.preventDefault();
    // e.target.setCustomValidity(' ');
    if (fieldValidation && fieldValidation.hideDefaultValidationMsg) {
      // document.querySelector(`#${fieldId}`).focus();
      setShowCustomInvalidMsg(true);
    } else {
      e.target.setCustomValidity(`${customInvalidMsg}`);
    }
    // invoke some error message red color
  };
  const onInputHandler = (e) => {
    e.target.setCustomValidity('');
    setShowCustomInvalidMsg(false);
  };

  return (
    <div className="row pad-1-l">
      {
        options.map((option) => (
          <div className="checkbox row col-lg-6 col-md-4 margin-3-t" key={option.fieldId}>
            <input
              id={option.fieldId}
              name={option.fieldId}
              type="checkbox"
              // name={fieldName}
              // value={option.value}
              required={option.fieldValidation.required}
              // disabled={option.disabled}
              value={option.optionSelected ? 'Yes' : null}
              checked={option.optionSelected}
              onChange={(e) => handleOnChange(e, option)}
              onInvalid={invalidHandler}
              onInput={onInputHandler}
            />
            <label htmlFor={option.fieldId} className="label-3">
              {parseHtml(option.fieldLabel)}
            </label>
            {option.nodeDetail && (
              <li
                className="col-md-offset-1"
              >
                {option.nodeDetail}
              </li>
            )}
          </div>
        ))
      }
      {showCustomInvalidMsg && (
        <div id="alert-error" className="alert dls-color-warning pad-1-t">
          <span className="icon icon-sm dls-icon-warning-filled pad-1-r" />
          <span>{customInvalidMsg}</span>
        </div>
      )}
    </div>
  );
};

GroupCheckboxesMultiSelect.propTypes = {
  fieldOptions: PropTypes.objectOf(PropTypes.shape),
  fieldValidation: PropTypes.objectOf(PropTypes.shape),
  formSubmissionPayload: PropTypes.objectOf(PropTypes.shape),
  setFormSubmissionPayload: PropTypes.objectOf(PropTypes.shape),
};

export default GroupCheckboxesMultiSelect;
